module.exports = __webpack_public_path__ + "f1525be60beb391819063e75e6331d27.png";